import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import toast from 'react-hot-toast';
import { AppDispatch, RootState } from '../../../reducers/store';
import { StateContactUsParams } from '../../../types/contactUs/contactUsParams';
import { actionDeleteContactUsMessage, actionFetchContactMessages } from '../../../actions/contactUs';
import { AddRounded, CloseRounded, DeleteRounded, DoNotDisturbAltRounded } from '@mui/icons-material';
import { Button, ImageBuffer, Loader, PageHeader, Pagination } from '../../../components';
import { ContactUsTableHeader } from '../../../utils/constants';

import './messages.css'

interface DeletePostParams {
  detailId: string;
  firstName: string;
}

const Messages = () => {
  const dispatch                                                 = useDispatch<AppDispatch>();
  const location                                                 = useLocation();
  const searchParams                                             = new URLSearchParams(location.search);
  const page                                                     = searchParams.get("page") || 1
  const {isLoading, getAllContactUs, numberOfPages, totalNumber} = useSelector((state: RootState) => state?.contactList);
  const [allPosts, setAllPosts]                                  = useState<StateContactUsParams[]>(getAllContactUs);
  const [isOpen, setIsOpen]                                      = useState<{ [key: number]: boolean }>({})

  const handleClick = (index: number) => () => {
    setIsOpen(prev => ({ [index]: !prev[index]}))
  }

  const handleDeletePost = ({detailId, firstName}: DeletePostParams) => {
    if (window.confirm(`Are you sure you want to delete message from ${firstName}?`)) {
    // Dispatch the deletePost action here
    dispatch(actionDeleteContactUsMessage({id:detailId}))
      .then(() => {
      setAllPosts(allPosts.filter(post => post._id !== detailId));
      // Show success toast after successfully deleting the post
      toast.success('User deleted successfully');
      })
      .catch((error) => {
      // Handle any errors that occur during the deletion process
      toast.error('Error deleting post: ' + error.message);
      });
    }
  };

  useEffect(() => {
    dispatch(actionFetchContactMessages({page})); // You can pass the page number as needed
  }, [dispatch, page]);

  if(!allPosts.length && !isLoading) return (
    <>
      <div className='empty-profile-card-wrapper'>
        <div className='empty-profile-card-header'>
          <span><DoNotDisturbAltRounded /></span>
          <h1> No Messages Found </h1>
        </div>
      </div>
    </>
  )

  return (
    <>
      <title>Contact Us</title>
      <PageHeader title="Contact Us" description="Welcome to the Messages" download="Download Report" />
      <div className='table-main-wrapper'>
        <div className='table-header'>
          <h3>Contact Us Messages</h3>
          {/* <Button buttonWrapper="button-wrapper" linkButton linkTo="users/create-users" linkClass="link-wrapper" linkName="View all" /> */}
        </div>
        
        {isLoading ? <Loader /> : (
          <table className='main-table'>
            <thead>
              <tr>
                {ContactUsTableHeader.map((option, index) => (
                  <th key={index}>{option.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {allPosts.map((detail, index) => {
                
              return (
                <tr key={index}>
                  <td data-cell="first name">{detail?.firstName}</td>
                  <td data-cell="last name">{detail?.lastName}</td>
                  <td data-cell="emailAddress">{detail?.emailAddress}</td>
                  <td data-cell="emailAddress">{detail?.message}</td>
                  <td data-cell="created">{moment(detail?.createdAt).format('YYYY-MM-DD')}</td>
                  <td data-cell="edit">
                    <div  className={isOpen[index] ? 'button-option active' : 'button-option'}>
                      <button className='button-option-head' onClick={handleClick(index)}>{isOpen[index] ? (<span><CloseRounded /></span>) : (<span><AddRounded /></span>)}</button>
                      <div className='button-menu-option'>
                        <button className='button-menu-detail' onClick={() => handleDeletePost({ detailId: detail._id, firstName: detail.firstName }) }>
                          <DeleteRounded />
                          <span>Delete</span>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              )})}
            </tbody>
          </table>
        )}

        <Pagination actionGet={actionFetchContactMessages} page={page} numberOfPages={numberOfPages} totalNumber={totalNumber} />
      </div>
    </>
  )
}

export default Messages